import { render, staticRenderFns } from "./poolCardStopWarn.vue?vue&type=template&id=64a1ae9e&scoped=true"
import script from "./poolCardStopWarn.vue?vue&type=script&lang=js"
export * from "./poolCardStopWarn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a1ae9e",
  null
  
)

export default component.exports